export class ReqSearchParamsObj {
    [key: string]: any
}